(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[57],{

/***/ 2329:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generator",
      function () {
        return __webpack_require__(2947);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ArtworkCard_ArtworkCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Modal/Modal.tsx
var Modal = __webpack_require__(5559);
// EXTERNAL MODULE: ./components/ArtworkCard/ArtworkCreator/ArtworkCreator.module.scss
var ArtworkCreator_module = __webpack_require__(3835);
var ArtworkCreator_module_default = /*#__PURE__*/__webpack_require__.n(ArtworkCreator_module);
// EXTERNAL MODULE: ./components/icons/user.tsx
var user = __webpack_require__(7235);
;// CONCATENATED MODULE: ./components/ArtworkCard/ArtworkCreator/ArtworkCreator.tsx



const ArtworkCreator = (props)=>{
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ArtworkCreator_module_default()).creatorContainer,
        children: [
            ((ref = props.creator) === null || ref === void 0 ? void 0 : ref.avatar) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: props.creator.avatar,
                alt: "avatar",
                loading: "lazy"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(user/* UserIcon */.t, {
                width: "48px",
                height: "48px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ArtworkCreator_module_default()).creatorInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "body-3 secondary",
                        children: props.creator.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "body-2 white",
                        children: props.creator.email
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ArtworkCreator_ArtworkCreator = (ArtworkCreator);

// EXTERNAL MODULE: ./components/Loaders/LoaderCircle/Loader.tsx
var Loader = __webpack_require__(9416);
;// CONCATENATED MODULE: ./components/AppImage/AppImage.tsx



const AppImage = (props)=>{
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative block w-full box-border",
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 flex items-center justify-center z-[1] rounded-lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
                    isLoading: true,
                    width: 32,
                    height: 32,
                    color: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                onClick: props.onClick,
                src: props.src,
                alt: props.alt,
                onLoad: ()=>setIsLoading(false),
                style: {
                    opacity: isLoading ? 0 : 1,
                    ...props.style
                },
                className: "transition-opacity duration-500 ease-in-out w-full h-auto object-cover rounded-lg",
                loading: "lazy"
            })
        ]
    });
};
/* harmony default export */ var AppImage_AppImage = (AppImage);

// EXTERNAL MODULE: ./components/ArtworkCard/ArtworkCardDetails/ArtworkCardDetails.module.scss
var ArtworkCardDetails_module = __webpack_require__(9383);
var ArtworkCardDetails_module_default = /*#__PURE__*/__webpack_require__.n(ArtworkCardDetails_module);
;// CONCATENATED MODULE: ./components/ArtworkCard/ArtworkCardDetails/ArtworkCardDetails.tsx




const ArtworkCardDetails = (props)=>{
    const [showForm, setShowForm] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ArtworkCardDetails_module_default()).artworkDetails,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ArtworkCardDetails_module_default()).artworkImageContent,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImage_AppImage, {
                src: props.artwork.image,
                alt: props.artwork.title
            })
        })
    });
};
/* harmony default export */ var ArtworkCardDetails_ArtworkCardDetails = (ArtworkCardDetails);

// EXTERNAL MODULE: ./components/icons/image.tsx
var icons_image = __webpack_require__(2605);
// EXTERNAL MODULE: ./context/AuthContext.tsx
var AuthContext = __webpack_require__(175);
;// CONCATENATED MODULE: ./hooks/useModal.ts

function useModal() {
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const toggleModal = ()=>{
        setIsOpen(!isOpen);
    };
    return {
        isOpen,
        toggleModal
    };
}

;// CONCATENATED MODULE: ./components/ArtworkCard/ArtworkCard.tsx









const ArtworkCard = (props)=>{
    var ref;
    const { user  } = (0,AuthContext/* useAuth */.aC)();
    const { isOpen , toggleModal  } = useModal();
    const initialStyles = {
        width: props.width,
        height: props.height,
        ...props.styles
    };
    const handleClick = ()=>{
        var ref;
        (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props);
        if (props.isModalEnabled) {
            toggleModal();
            return;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 sm:w-1/3 mx-auto overflow-hidden rounded-lg cursor-pointer box-border",
                style: initialStyles,
                children: ((ref = props.artwork) === null || ref === void 0 ? void 0 : ref.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImage_AppImage, {
                    onClick: handleClick,
                    src: props.artwork.image,
                    alt: props.artwork.title
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_image/* ImageIcon */.X, {})
                })
            }),
            props.isModalEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                width: "auto",
                height: "auto",
                showHeader: true,
                isOpen: isOpen,
                toggleModal: toggleModal,
                headerContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtworkCreator_ArtworkCreator, {
                    creator: user
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtworkCardDetails_ArtworkCardDetails, {
                        artwork: props.artwork,
                        toggleModal: toggleModal,
                        refreshArtworks: props.refreshArtworks
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ArtworkCard_ArtworkCard = (ArtworkCard);


/***/ }),

/***/ 718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_strings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4574);
/* harmony import */ var _validators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9200);
/* harmony import */ var _TextArea_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3631);
/* harmony import */ var _TextArea_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_TextArea_module_scss__WEBPACK_IMPORTED_MODULE_3__);





const grammarlyAttributes = {
    "data-gramm": "false",
    "data-gramm_editor": "false",
    "data-enable-grammarly": "false"
};
const InputTextArea = (param)=>{
    let { automaticValidation =true , ...props } = param;
    var ref;
    const textareaRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [textareaHeight, setTextareaHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("auto");
    const extraAttributes = props.disableGrammarly ? grammarlyAttributes : {};
    const handleChange = (event)=>{
        const value = event.target.value;
        event.persist();
        adjustTextareaHeight(event.target);
        props.setText && props.setText({
            value: value,
            validators: automaticValidation ? (0,_validators__WEBPACK_IMPORTED_MODULE_2__/* .getInputValidators */ .Ex)(value, props.isRequired, props.minValueLength, props.maxValueLength) : []
        });
    };
    const adjustTextareaHeight = (element)=>{
        element.style.height = "auto";
        element.style.height = "".concat(element.scrollHeight, "px");
        setTextareaHeight("".concat(element.scrollHeight, "px"));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (textareaRef.current) {
            adjustTextareaHeight(textareaRef.current);
        }
    }, [
        props.text.value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: props.styles,
                className: "".concat((_TextArea_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[props.variant || "default"]),
                children: [
                    props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: props.id,
                        className: "base-2 white",
                        children: props.label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                        id: props.id,
                        autoFocus: props.autoFocus,
                        className: "".concat((_TextArea_module_scss__WEBPACK_IMPORTED_MODULE_3___default().textArea), " ").concat(props.rightIcon && (_TextArea_module_scss__WEBPACK_IMPORTED_MODULE_3___default().pRight), " "),
                        placeholder: props.placeholder,
                        value: props.text.value,
                        disabled: props.disabled,
                        onChange: handleChange,
                        ...extraAttributes,
                        style: {
                            height: textareaHeight,
                            ...props.inputStyles
                        },
                        ref: textareaRef,
                        rows: 1,
                        onClick: props.onClick
                    }),
                    props.rightIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_TextArea_module_scss__WEBPACK_IMPORTED_MODULE_3___default().rightIcon),
                        children: props.rightIcon
                    }),
                    props.showCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "base-2 ".concat(props.color, " ").concat((_TextArea_module_scss__WEBPACK_IMPORTED_MODULE_3___default().count)),
                        children: [
                            (ref = props.text.value) === null || ref === void 0 ? void 0 : ref.length,
                            props.maxValueLength ? " / " + props.maxValueLength : ""
                        ]
                    })
                ]
            }),
            props.text.validators && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                className: (_TextArea_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error),
                children: (0,_utils_strings__WEBPACK_IMPORTED_MODULE_4__/* .buildStringFromArray */ .Gj)(props.text.validators)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InputTextArea);


/***/ }),

/***/ 2605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ImageIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const ImageIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});


/***/ }),

/***/ 7315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SaleIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const SaleIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "75",
        height: "75",
        viewBox: "0 0 75 75",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M26.0539 73.5H5C3.067 73.5 1.5 71.933 1.5 70L1.5 48.9461C1.5 48.0178 1.86875 47.1276 2.52513 46.4712L44.4001 4.59619C45.767 3.22935 47.983 3.22935 49.3499 4.59619L70.4038 25.6501C71.7706 27.017 71.7706 29.233 70.4038 30.5999L28.5288 72.4749C27.8724 73.1313 26.9822 73.5 26.0539 73.5ZM18.75 45.375C12.7653 45.375 7.875 50.2653 7.875 56.25C7.875 62.2347 12.7653 67.125 18.75 67.125C24.7347 67.125 29.625 62.2347 29.625 56.25C29.625 50.2653 24.7347 45.375 18.75 45.375Z",
                fill: "#AA69F4",
                stroke: "black",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M35.646 45.7209C35.0835 46.2833 34.4882 46.696 33.86 46.959C33.2318 47.222 32.6036 47.3097 31.9753 47.222C31.3544 47.127 30.7847 46.8348 30.266 46.3454L32.2602 44.3512C32.5743 44.6069 32.8921 44.7274 33.2135 44.7128C33.5276 44.6909 33.8198 44.5448 34.0901 44.2745C34.3677 43.9969 34.5247 43.7157 34.5612 43.4308C34.5905 43.1386 34.4919 42.8793 34.2654 42.6528C34.0755 42.4629 33.8527 42.3716 33.597 42.3789C33.3486 42.3789 33.0893 42.4337 32.819 42.5433C32.5561 42.6455 32.2018 42.8172 31.7562 43.0582C31.1061 43.4016 30.5472 43.6536 30.0797 43.8143C29.6122 43.975 29.1155 44.0188 28.5896 43.9458C28.0636 43.8727 27.5596 43.5952 27.0775 43.113C26.3616 42.3972 26.0621 41.579 26.179 40.6586C26.2885 39.7309 26.7597 38.8507 27.5924 38.0179C28.4398 37.1706 29.3273 36.6921 30.2551 36.5825C31.1755 36.4656 32.0155 36.7505 32.7752 37.4372L30.7481 39.4643C30.4852 39.2305 30.2003 39.1283 29.8935 39.1575C29.5794 39.1794 29.2908 39.3218 29.0278 39.5848C28.8014 39.8113 28.6809 40.056 28.6663 40.3189C28.6443 40.5746 28.7466 40.8157 28.9731 41.0421C29.2214 41.2905 29.5319 41.3672 29.9044 41.2722C30.277 41.1773 30.792 40.9618 31.4494 40.6257C32.1141 40.297 32.6766 40.056 33.1368 39.9026C33.6043 39.7419 34.0974 39.6944 34.616 39.7601C35.1347 39.8259 35.6241 40.0888 36.0843 40.549C36.5226 40.9873 36.8075 41.4987 36.939 42.0831C37.0778 42.6601 37.0412 43.2664 36.8294 43.902C36.6176 44.5375 36.2231 45.1438 35.646 45.7209Z",
                fill: "#EBDA45"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M42.9571 35.539L40.0863 38.4098L40.9848 40.2287L39.0234 42.1901L34.1146 31.7149L36.2841 29.5454L46.7592 34.4543L44.776 36.4375L42.9571 35.539ZM41.0286 34.5748L37.2593 32.7121L39.133 36.4704L41.0286 34.5748Z",
                fill: "#EBDA45"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M48.0336 30.2872L50.488 27.8327L51.9344 29.2791L47.6063 33.6072L39.9143 25.9152L41.788 24.0415L48.0336 30.2872Z",
                fill: "#EBDA45"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M48.5109 20.3209L50.0668 21.8768L52.5761 19.3676L54.0224 20.814L51.5132 23.3232L53.2006 25.0106L56.0385 22.1726L57.5397 23.6738L52.8281 28.3854L45.1361 20.6934L49.8477 15.9818L51.3488 17.483L48.5109 20.3209Z",
                fill: "#EBDA45"
            })
        ]
    });


/***/ }),

/***/ 2947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ generator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/Navbar/Navbar.tsx + 4 modules
var Navbar = __webpack_require__(4958);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Inputs/InputTextArea/InputTextArea.tsx
var InputTextArea = __webpack_require__(718);
// EXTERNAL MODULE: ./components/Inputs/InputText/InputText.tsx
var InputText = __webpack_require__(2469);
// EXTERNAL MODULE: ./context/SDContext.tsx + 5 modules
var SDContext = __webpack_require__(9498);
// EXTERNAL MODULE: ./context/ImagineContext.tsx + 5 modules
var ImagineContext = __webpack_require__(7524);
// EXTERNAL MODULE: ./components/buttons/ButtonSecondary/ButtonSecondary.tsx
var ButtonSecondary = __webpack_require__(749);
;// CONCATENATED MODULE: ./components/ImagineInput/ImagineInput.tsx







const clearPrompt = (props)=>{
    if (!props.isPromptEmpty) {
        props.setIsPromptEmpty(true);
        props.setPrompt(InputText/* initialText */.WG);
    }
};
const ImagineInput = (props)=>{
    const { prompt , setPrompt  } = (0,SDContext/* useDiffusion */.PW)();
    const { isLoading , preview  } = (0,ImagineContext/* useImagine */.Y)();
    const [isPromptEmpty, setIsPromptEmpty] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-12 gap-2 sm:gap-4 w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 sm:col-span-9",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextArea/* default */.Z, {
                    id: "textAreaImagine",
                    autoFocus: true,
                    text: prompt,
                    disabled: !!preview,
                    placeholder: "Write your prompt here",
                    setText: setPrompt,
                    isRequired: true,
                    disableGrammarly: true,
                    onClick: ()=>clearPrompt({
                            isPromptEmpty,
                            setIsPromptEmpty,
                            setPrompt
                        }),
                    automaticValidation: false,
                    variant: "colour"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-12 sm:col-span-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                    loading: isLoading && !preview,
                    onClick: props.handleGenerate,
                    disabled: !props.isFormValid || isLoading,
                    text: "Generate (1 credit)",
                    size: "lg",
                    className: "w-full"
                })
            })
        ]
    });
};
/* harmony default export */ var ImagineInput_ImagineInput = (ImagineInput);

// EXTERNAL MODULE: ./components/Auth/PrivateRoute/PrivateRoute.tsx
var PrivateRoute = __webpack_require__(3552);
// EXTERNAL MODULE: ./layout/ImagineContainer/ImagineContainer.module.scss
var ImagineContainer_module = __webpack_require__(6820);
var ImagineContainer_module_default = /*#__PURE__*/__webpack_require__.n(ImagineContainer_module);
;// CONCATENATED MODULE: ./layout/ImagineContainer/ImagineContainer.tsx





const ImagineContainer = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivateRoute/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ImagineContainer_module_default()).imagineContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ImagineContainer_module_default()).imagineContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: (ImagineContainer_module_default()).mainContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ImagineContainer_module_default()).children,
                                children: props.children
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ImagineContainer_module_default()).input,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagineInput_ImagineInput, {
                                    isFormValid: props.formValid,
                                    handleGenerate: props.handleGenerate
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ImagineContainer_ImagineContainer = (ImagineContainer);

// EXTERNAL MODULE: ./components/ArtworkCard/ArtworkCard.tsx + 4 modules
var ArtworkCard = __webpack_require__(3937);
// EXTERNAL MODULE: ./components/ImageGallery/ImageGallery.module.scss
var ImageGallery_module = __webpack_require__(5236);
var ImageGallery_module_default = /*#__PURE__*/__webpack_require__.n(ImageGallery_module);
;// CONCATENATED MODULE: ./components/ImageGallery/ImageGallery.tsx





const ImageGallery = (props)=>{
    var ref, ref1;
    const { isLoading , resultImages  } = (0,ImagineContext/* useImagine */.Y)();
    (0,react.useEffect)(()=>{}, [
        resultImages
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: ((ref = props.ArtWorks) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ImageGallery_module_default()).galleryContainer,
            children: props.ArtWorks.map((result, indexParent)=>{
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: (ImageGallery_module_default()).promptResults,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ImageGallery_module_default()).galleryRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "body-2 mb-4 center",
                                children: (ref = result.prompt) === null || ref === void 0 ? void 0 : ref.prompt
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtworkCard/* default */.Z, {
                                artwork: {
                                    image: result.preview || result.image || "",
                                    prompt: result.prompt
                                },
                                isModalEnabled: false,
                                onClick: ()=>{
                                    props.onClick(result);
                                }
                            })
                        ]
                    })
                }, indexParent);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ImageGallery_module_default()).galleryContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ImageGallery_module_default()).promptResults,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ImageGallery_module_default()).galleryRow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-3 w-2/3 rounded bg-[#252238] mb-4 "
                        }),
                        ((ref1 = resultImages[0]) === null || ref1 === void 0 ? void 0 : ref1.images[0]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: resultImages[0].images[0],
                            alt: "generated skin",
                            className: "w-full aspect-square rounded-xl object-cover"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full aspect-square rounded-xl bg-[#252238]"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var ImageGallery_ImageGallery = (ImageGallery);

// EXTERNAL MODULE: ./components/Loaders/LoaderCircle/Loader.tsx
var Loader = __webpack_require__(9416);
// EXTERNAL MODULE: ./components/MinecraftSkin/MinecraftSkin.module.scss
var MinecraftSkin_module = __webpack_require__(5558);
var MinecraftSkin_module_default = /*#__PURE__*/__webpack_require__.n(MinecraftSkin_module);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.ts + 1 modules
var useWindowDimensions = __webpack_require__(7463);
;// CONCATENATED MODULE: ./components/MinecraftSkin/MinecraftSkin.tsx





const MinecraftSkin = (props)=>{
    const skinContainerRef = (0,react.useRef)(null);
    const { isMobile  } = (0,useWindowDimensions/* default */.Z)();
    const startTime = Date.now();
    const _skinRender = (0,react.useRef)(null);
    const skinRenderEventListener = (0,react.useRef)(null);
    const [loaded, setLoaded] = (0,react.useState)(false);
    const [mobileAnimation, setMobileAnimation] = (0,react.useState)(true);
    const [rendererLoaded, setRendererLoaded] = (0,react.useState)(false);
    const [mouseIsDown, setMouseIsDown] = (0,react.useState)(false);
    const [skinLoading, setSkinLoading] = (0,react.useState)(true);
    const skinLoadingRef = (0,react.useRef)(true);
    const shouldAnimate = props.toggleAnimation && (isMobile && mobileAnimation || !isMobile);
    (0,react.useEffect)(()=>{
        const loadScript = (src, integrity, crossorigin)=>{
            return new Promise((resolve, reject)=>{
                const script = document.createElement("script");
                script.src = src;
                if (integrity) script.integrity = integrity;
                if (crossorigin) script.crossOrigin = crossorigin;
                script.onload = ()=>resolve(0);
                script.onerror = ()=>reject(new Error("Failed to load script ".concat(src)));
                document.body.appendChild(script);
            });
        };
        const loadDependencies = async ()=>{
            await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js", "sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8=", "anonymous");
            await loadScript("https://cdnjs.cloudflare.com/ajax/libs/three.js/94/three.min.js", "sha256-NGC9JEuTWN4GhTj091wctgjzftr+8WNDmw0H8J5YPYE=", "anonymous");
            await loadScript("./skin.min.js");
        };
        loadDependencies().then(()=>{
            setLoaded(true);
        }).catch((err)=>console.error(err));
    }, []);
    (0,react.useEffect)(()=>{
        if (!loaded || !skinContainerRef.current || !props.url) return;
        skinLoadingRef.current = true;
        setSkinLoading(true);
        if (_skinRender.current) {
            var ref;
            const skinRender = _skinRender.current;
            if ((ref = skinRender._scene) === null || ref === void 0 ? void 0 : ref.children) {
                skinRender.clearScene(true);
            }
            // Defer to next frame so Three.js camera is re-initialized after clearScene
            const raf = requestAnimationFrame(()=>{
                skinRender.render(props.url);
            });
            return ()=>cancelAnimationFrame(raf);
        }
        if (!window.SkinRender) return;
        const canvasWidth = skinContainerRef.current.offsetWidth;
        const canvasHeight = skinContainerRef.current.offsetHeight;
        const createRenderer = (width, height)=>{
            if (!skinContainerRef.current) return;
            _skinRender.current = new window.SkinRender({
                controls: {
                    keys: false
                },
                canvas: {
                    width,
                    height
                },
                pauseHidden: false,
                autoResize: true,
                sendStats: false
            }, skinContainerRef.current);
            // Defer render() to next frame — canvas must be laid out before
            // SkinRender initialises its Three.js OrthographicCamera (.right etc.)
            const raf = requestAnimationFrame(()=>{
                if (_skinRender.current) {
                    _skinRender.current.render(props.url);
                    setRendererLoaded(true);
                }
            });
            return raf;
        };
        if (canvasWidth === 0 || canvasHeight === 0) {
            const retryTimeout = setTimeout(()=>{
                if (!skinContainerRef.current) return;
                const w = skinContainerRef.current.offsetWidth;
                const h = skinContainerRef.current.offsetHeight;
                if (w > 0 && h > 0) createRenderer(w, h);
            }, 100);
            return ()=>clearTimeout(retryTimeout);
        }
        const raf1 = createRenderer(canvasWidth, canvasHeight);
        return ()=>{
            if (raf1) cancelAnimationFrame(raf1);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.url,
        loaded
    ]);
    (0,react.useEffect)(()=>{
        if (rendererLoaded) {
            skinRenderEventListener.current = function(e) {
                var ref, ref1, ref2;
                if (skinLoadingRef.current) {
                    skinLoadingRef.current = false;
                    setSkinLoading(false);
                }
                const t = (Date.now() - startTime) / 1000;
                if ((e === null || e === void 0 ? void 0 : (ref = e.detail) === null || ref === void 0 ? void 0 : (ref1 = ref.playerModel) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.children) === null || ref2 === void 0 ? void 0 : ref2.length) === 6) {
                    if (shouldAnimate) {
                        e.detail.playerModel.children[2].rotation.x = Math.sin(t * 5) / 2;
                        e.detail.playerModel.children[3].rotation.x = -Math.sin(t * 5) / 2;
                        e.detail.playerModel.children[4].rotation.x = Math.sin(t * 5) / 2;
                        e.detail.playerModel.children[5].rotation.x = -Math.sin(t * 5) / 2;
                    } else if (props.staticPose === "walking") {
                        e.detail.playerModel.rotation.y = -Math.PI / 6;
                        // Arms - natural swing
                        e.detail.playerModel.children[2].rotation.x = -0.6; // Right arm back
                        e.detail.playerModel.children[2].rotation.z = -0.1; // Right arm slightly out
                        e.detail.playerModel.children[3].rotation.x = 0.6; // Left arm forward
                        e.detail.playerModel.children[3].rotation.z = 0.1; // Left arm slightly out
                        // Legs - wider step
                        e.detail.playerModel.children[4].rotation.x = 0.7; // Right leg forward (wider)
                        e.detail.playerModel.children[5].rotation.x = -0.7; // Left leg back (wider)
                    } else {
                        // Standing pose: all limbs straight
                        e.detail.playerModel.children[2].rotation.x = 0;
                        e.detail.playerModel.children[3].rotation.x = 0;
                        e.detail.playerModel.children[4].rotation.x = 0;
                        e.detail.playerModel.children[5].rotation.x = 0;
                    }
                }
            };
            _skinRender.current.element.addEventListener("skinRender", skinRenderEventListener.current);
            return ()=>{
                if (skinRenderEventListener.current) {
                    _skinRender.current.element.removeEventListener("skinRender", skinRenderEventListener.current);
                }
            };
        }
    }, [
        rendererLoaded,
        shouldAnimate
    ]);
    const handleMouseDown = ()=>{
        setMouseIsDown(true);
        setTimeout(()=>{
            setMouseIsDown(false);
        }, 500);
    };
    const handleMouseUp = ()=>{
        if (mouseIsDown && isMobile) {
            setMobileAnimation(!mobileAnimation);
        }
        setMouseIsDown(false);
    };
    // Fallback: hide spinner if skinRender event never fires (e.g. bad URL)
    (0,react.useEffect)(()=>{
        if (!skinLoading) return;
        const timeout = setTimeout(()=>{
            skinLoadingRef.current = false;
            setSkinLoading(false);
        }, 10000);
        return ()=>clearTimeout(timeout);
    }, [
        skinLoading,
        props.url
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (MinecraftSkin_module_default()).minecraftSkinContainer,
            id: "minecraftSkinContainer",
            ref: skinContainerRef,
            onMouseDown: handleMouseDown,
            onMouseUp: handleMouseUp,
            children: skinLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 flex items-center justify-center rounded-xl",
                style: {
                    zIndex: 10,
                    background: "var(--foreground)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
                    isLoading: true,
                    width: 36,
                    height: 36,
                    color: "white"
                })
            })
        })
    });
};
/* harmony default export */ var MinecraftSkin_MinecraftSkin = (MinecraftSkin);

// EXTERNAL MODULE: ./node_modules/three/build/three.core.js
var three_core = __webpack_require__(4250);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(9477);
// EXTERNAL MODULE: ./node_modules/three/examples/jsm/controls/OrbitControls.js
var OrbitControls = __webpack_require__(9365);
// EXTERNAL MODULE: ./components/MinecraftSkinEditor/MinecraftSkinEditor.module.scss
var MinecraftSkinEditor_module = __webpack_require__(8429);
var MinecraftSkinEditor_module_default = /*#__PURE__*/__webpack_require__.n(MinecraftSkinEditor_module);
;// CONCATENATED MODULE: ./components/MinecraftSkinEditor/MinecraftSkinEditor.tsx





const PALETTE = [
    "#FF0000",
    "#00FF00",
    "#0000FF",
    "#FFFF00",
    "#00FFFF",
    "#FF00FF",
    "#FFFFFF",
    "#C0C0C0",
    "#808080",
    "#404040",
    "#000000",
    "#F0C090",
    "#7F5229",
    "#533010",
    "#FF9900",
    "#CC6600",
    "#663300",
    "#331900" // Browns
];
function MinecraftSkinEditor(param) {
    let { skinUrl , onSave , onCancel  } = param;
    const canvasRef = (0,react.useRef)(null);
    const [brushColor, setBrushColor] = (0,react.useState)("#FF0000");
    const [brushSize, setBrushSize] = (0,react.useState)(1);
    const [isEraser, setIsEraser] = (0,react.useState)(false);
    const [isAnimating, setIsAnimating] = (0,react.useState)(false);
    const engineRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!canvasRef.current) return;
        const engine = new SkinEditorEngine(canvasRef.current);
        engineRef.current = engine;
        return ()=>{
            engine.dispose();
            engineRef.current = null;
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (engineRef.current && skinUrl) engineRef.current.loadSkinFromUrl(skinUrl);
    }, [
        skinUrl
    ]);
    (0,react.useEffect)(()=>{
        if (engineRef.current) engineRef.current.setAnimation(isAnimating);
    }, [
        isAnimating
    ]);
    (0,react.useEffect)(()=>{
        if (engineRef.current) engineRef.current.setBrushColor(brushColor);
    }, [
        brushColor
    ]);
    (0,react.useEffect)(()=>{
        if (engineRef.current) engineRef.current.setBrushSize(brushSize);
    }, [
        brushSize
    ]);
    (0,react.useEffect)(()=>{
        if (engineRef.current) engineRef.current.setEraserMode(isEraser);
    }, [
        isEraser
    ]);
    const handleSave = ()=>{
        if (engineRef.current && onSave) {
            onSave(engineRef.current.getSkinDataUrl());
        }
    };
    const handleReset = ()=>{
        if (engineRef.current) {
            if (confirm("Reset to original skin? All changes will be lost.")) {
                engineRef.current.revertToOriginal();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (MinecraftSkinEditor_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
                ref: canvasRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MinecraftSkinEditor_module_default()).controlsOverlay,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MinecraftSkinEditor_module_default()).toolsContainer,
                        children: [
                            onCancel && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (MinecraftSkinEditor_module_default()).toolButton,
                                onClick: onCancel,
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "".concat((MinecraftSkinEditor_module_default()).toolButton, " ").concat(isEraser ? (MinecraftSkinEditor_module_default()).active : ""),
                                onClick: ()=>setIsEraser(!isEraser),
                                children: isEraser ? "Brush" : "Eraser"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "".concat((MinecraftSkinEditor_module_default()).toolButton, " ").concat(isAnimating ? (MinecraftSkinEditor_module_default()).active : ""),
                                onClick: ()=>setIsAnimating(!isAnimating),
                                children: isAnimating ? "Stop" : "Walk"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (MinecraftSkinEditor_module_default()).toolButton,
                                onClick: handleReset,
                                children: "Reset"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (MinecraftSkinEditor_module_default()).toolButton,
                                onClick: handleSave,
                                children: "Save"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-white text-xs mb-1",
                        children: "Select Color"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MinecraftSkinEditor_module_default()).colorPickerContainer,
                        children: [
                            PALETTE.map((color)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((MinecraftSkinEditor_module_default()).colorSwatch, " ").concat(brushColor === color ? (MinecraftSkinEditor_module_default()).active : ""),
                                    style: {
                                        backgroundColor: color
                                    },
                                    onClick: ()=>setBrushColor(color)
                                }, color)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "color",
                                value: brushColor,
                                onChange: (e)=>setBrushColor(e.target.value),
                                className: (MinecraftSkinEditor_module_default()).colorSwatch,
                                style: {
                                    padding: 0
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// ------------------------------------------------------------------
// Skin Editor Engine - High Fidelity (Overlays + Angled Camera)
// ------------------------------------------------------------------
class SkinEditorEngine {
    init(canvas) {
        this.scene = new three_core/* Scene */.xsS();
        const parent = canvas.parentElement;
        const width = (parent === null || parent === void 0 ? void 0 : parent.clientWidth) || 300;
        const height = (parent === null || parent === void 0 ? void 0 : parent.clientHeight) || 400;
        this.camera = new three_core/* PerspectiveCamera */.cPb(60, width / height, 0.1, 1000);
        this.camera.position.set(-15, 15, 30);
        this.renderer = new three_module/* WebGLRenderer */.CP7({
            canvas,
            antialias: true,
            alpha: true
        });
        this.renderer.setSize(width, height);
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = three_core/* PCFSoftShadowMap */.ntZ;
        this.renderer.toneMapping = three_core/* NoToneMapping */.uL9;
        this.controls = new OrbitControls/* OrbitControls */.z(this.camera, canvas);
        this.controls.enableDamping = true;
        this.controls.dampingFactor = 0.05;
        this.controls.target.set(0, 10, 0);
        // Standard lighting for accurate color editing
        const ambientLight = new three_core/* AmbientLight */.Mig(0xffffff, 0.8);
        this.scene.add(ambientLight);
        const dirLight = new three_core/* DirectionalLight */.Ox3(0xffffff, 0.4);
        dirLight.position.set(10, 20, 10);
        dirLight.castShadow = true;
        this.scene.add(dirLight);
        const dirLight2 = new three_core/* DirectionalLight */.Ox3(0xffffff, 0.3);
        dirLight2.position.set(-10, 10, -10);
        this.scene.add(dirLight2);
        // Add ground plane for shadows
        const groundGeometry = new three_core/* PlaneGeometry */._12(100, 100);
        const groundMaterial = new three_core/* ShadowMaterial */.Tn7({
            opacity: 0.3
        });
        const ground = new three_core/* Mesh */.Kj0(groundGeometry, groundMaterial);
        ground.rotation.x = -Math.PI / 2;
        ground.position.y = -0.5;
        ground.receiveShadow = true;
        this.scene.add(ground);
        window.addEventListener("resize", this.onResize);
        this.onResize();
    }
    createDefaultSkin() {
        this.skinCanvas = document.createElement("canvas");
        this.skinCanvas.width = 64;
        this.skinCanvas.height = 64;
        this.skinContext = this.skinCanvas.getContext("2d");
        this.skinContext.fillStyle = "#AAAAAA";
        this.skinContext.fillRect(0, 0, 64, 64);
        this.skinTexture = new three_core/* CanvasTexture */.ROQ(this.skinCanvas);
        this.skinTexture.magFilter = three_core/* NearestFilter */.TyD;
        this.skinTexture.minFilter = three_core/* NearestFilter */.TyD;
    }
    createCharacter() {
        // Use MeshLambertMaterial for accurate color representation
        const mat = new three_core/* MeshLambertMaterial */.YBo({
            map: this.skinTexture,
            color: 0xffffff
        });
        const transMat = new three_core/* MeshLambertMaterial */.YBo({
            map: this.skinTexture,
            color: 0xffffff,
            transparent: true,
            side: three_core/* DoubleSide */.ehD,
            alphaTest: 0.5
        });
        const createPart = function(w, h, d, name, yPos) {
            let xPos = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, zPos = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0;
            const geo = new three_core/* BoxGeometry */.DvJ(w, h, d);
            const mesh = new three_core/* Mesh */.Kj0(geo, mat);
            mesh.position.set(xPos, yPos, zPos);
            mesh.name = name;
            mesh.castShadow = true;
            mesh.receiveShadow = true;
            return {
                mesh,
                geo
            };
        };
        const createOverlay = (parent, w, h, d)=>{
            const geo = new three_core/* BoxGeometry */.DvJ(w, h, d);
            const mesh = new three_core/* Mesh */.Kj0(geo, transMat);
            mesh.position.set(0, 0, 0);
            mesh.renderOrder = 1;
            mesh.name = "overlay";
            parent.add(mesh);
            return {
                mesh,
                geo
            };
        };
        const head = createPart(8, 8, 8, "head", 16);
        this.setHeadUVs(head.geo);
        this.character.add(head.mesh);
        this.addPixelGrid(head.mesh, 8, 8, 8);
        const headOv = createOverlay(head.mesh, 9, 9, 9);
        this.setHeadOverlayUVs(headOv.geo);
        const body = createPart(8, 12, 4, "body", 6);
        this.setBodyUVs(body.geo);
        this.character.add(body.mesh);
        this.addPixelGrid(body.mesh, 8, 12, 4);
        const bodyOv = createOverlay(body.mesh, 8.5, 12.5, 4.5);
        this.setBodyOverlayUVs(bodyOv.geo);
        const rArmGeo = new three_core/* BoxGeometry */.DvJ(4, 12, 4);
        rArmGeo.translate(0, -6, 0);
        const rArm = new three_core/* Mesh */.Kj0(rArmGeo, mat);
        rArm.position.set(-6, 12, 0);
        rArm.name = "rightArm";
        this.setRightArmUVs(rArmGeo);
        this.character.add(rArm);
        this.rightArm = rArm;
        this.addPixelGrid(rArm, 4, 12, 4, 6);
        const rArmOvGeo = new three_core/* BoxGeometry */.DvJ(4.5, 12.5, 4.5);
        rArmOvGeo.translate(0, -6, 0);
        const rArmOv = new three_core/* Mesh */.Kj0(rArmOvGeo, transMat);
        rArmOv.name = "overlay";
        this.setRightArmOverlayUVs(rArmOvGeo);
        rArm.add(rArmOv);
        const lArmGeo = new three_core/* BoxGeometry */.DvJ(4, 12, 4);
        lArmGeo.translate(0, -6, 0);
        const lArm = new three_core/* Mesh */.Kj0(lArmGeo, mat);
        lArm.position.set(6, 12, 0);
        lArm.name = "leftArm";
        this.setLeftArmUVs(lArmGeo);
        this.character.add(lArm);
        this.leftArm = lArm;
        this.addPixelGrid(lArm, 4, 12, 4, 6);
        const lArmOvGeo = new three_core/* BoxGeometry */.DvJ(4.5, 12.5, 4.5);
        lArmOvGeo.translate(0, -6, 0);
        const lArmOv = new three_core/* Mesh */.Kj0(lArmOvGeo, transMat);
        lArmOv.name = "overlay";
        this.setLeftArmOverlayUVs(lArmOvGeo);
        lArm.add(lArmOv);
        const rLegGeo = new three_core/* BoxGeometry */.DvJ(4, 12, 4);
        rLegGeo.translate(0, -6, 0);
        const rLeg = new three_core/* Mesh */.Kj0(rLegGeo, mat);
        rLeg.position.set(-2, 0, 0);
        rLeg.name = "rightLeg";
        this.setRightLegUVs(rLegGeo);
        this.character.add(rLeg);
        this.rightLeg = rLeg;
        this.addPixelGrid(rLeg, 4, 12, 4, 6);
        const rLegOvGeo = new three_core/* BoxGeometry */.DvJ(4.5, 12.5, 4.5);
        rLegOvGeo.translate(0, -6, 0);
        const rLegOv = new three_core/* Mesh */.Kj0(rLegOvGeo, transMat);
        rLegOv.name = "overlay";
        this.setRightLegOverlayUVs(rLegOvGeo);
        rLeg.add(rLegOv);
        const lLegGeo = new three_core/* BoxGeometry */.DvJ(4, 12, 4);
        lLegGeo.translate(0, -6, 0);
        const lLeg = new three_core/* Mesh */.Kj0(lLegGeo, mat);
        lLeg.position.set(2, 0, 0);
        lLeg.name = "leftLeg";
        this.setLeftLegUVs(lLegGeo);
        this.character.add(lLeg);
        this.leftLeg = lLeg;
        this.addPixelGrid(lLeg, 4, 12, 4, 6);
        const lLegOvGeo = new three_core/* BoxGeometry */.DvJ(4.5, 12.5, 4.5);
        lLegOvGeo.translate(0, -6, 0);
        const lLegOv = new three_core/* Mesh */.Kj0(lLegOvGeo, transMat);
        lLegOv.name = "overlay";
        this.setLeftLegOverlayUVs(lLegOvGeo);
        lLeg.add(lLegOv);
        this.scene.add(this.character);
    }
    loadSkinFromUrl(url) {
        const img = new Image();
        if (!url.startsWith("data:")) img.crossOrigin = "Anonymous";
        img.onload = ()=>{
            this.skinContext.clearRect(0, 0, 64, 64);
            this.skinContext.drawImage(img, 0, 0, 64, 64);
            this.originalSkinData = this.skinContext.getImageData(0, 0, 64, 64);
            this.skinTexture.needsUpdate = true;
        };
        img.src = url;
    }
    getSkinDataUrl() {
        return this.skinCanvas.toDataURL("image/png");
    }
    setBrushColor(color) {
        this.brushColor = color;
    }
    setBrushSize(size) {
        this.brushSize = Math.max(1, Math.min(10, size));
    }
    setEraserMode(enabled) {
        this.isEraser = enabled;
    }
    revertToOriginal() {
        if (this.originalSkinData) {
            this.skinContext.putImageData(this.originalSkinData, 0, 0);
            this.skinTexture.needsUpdate = true;
        }
    }
    setAnimation(enabled) {
        this._isAnimating = enabled;
        if (!enabled) {
            this.rightArm.rotation.x = this.leftArm.rotation.x = this.rightLeg.rotation.x = this.leftLeg.rotation.x = 0;
        }
    }
    setupEventListeners(canvas) {
        canvas.addEventListener("mousedown", this.onMouseDown, true);
        canvas.addEventListener("mousemove", this.onMouseMove);
        window.addEventListener("mouseup", this.onMouseUp);
    }
    paint(event) {
        const rect = this.renderer.domElement.getBoundingClientRect();
        this.mouse.x = (event.clientX - rect.left) / rect.width * 2 - 1;
        this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.camera);
        const meshes = [];
        this.character.traverse((obj)=>{
            if (obj.isMesh) {
                meshes.push(obj);
            }
        });
        const intersects = this.raycaster.intersectObjects(meshes, false);
        if (intersects.length > 0) {
            const uv = intersects[0].uv;
            if (uv) {
                const centerX = Math.floor(uv.x * 64);
                const centerY = Math.floor((1 - uv.y) * 64);
                // Paint with brush size (square brush)
                const halfSize = Math.floor(this.brushSize / 2);
                for(let dx = -halfSize; dx <= halfSize; dx++){
                    for(let dy = -halfSize; dy <= halfSize; dy++){
                        const x = centerX + dx;
                        const y = centerY + dy;
                        // Ensure we stay within bounds
                        if (x >= 0 && x < 64 && y >= 0 && y < 64) {
                            if (this.isEraser) {
                                this.skinContext.clearRect(x, y, 1, 1);
                            } else {
                                this.skinContext.fillStyle = this.brushColor;
                                this.skinContext.fillRect(x, y, 1, 1);
                            }
                        }
                    }
                }
                this.skinTexture.needsUpdate = true;
                return true;
            }
        }
        return false;
    }
    dispose() {
        if (this.animationFrameId) cancelAnimationFrame(this.animationFrameId);
        window.removeEventListener("resize", this.onResize);
        window.removeEventListener("mouseup", this.onMouseUp);
        this.renderer.dispose();
    }
    setFaceUVs(uvs, faceIndex, x, y, width, height) {
        let flipVertical = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
        const index = faceIndex * 8;
        const u1 = x / 64;
        const v1 = 1 - y / 64;
        const u2 = (x + width) / 64;
        const v2 = 1 - (y + height) / 64;
        const vTop = flipVertical ? v2 : v1;
        const vBottom = flipVertical ? v1 : v2;
        uvs[index] = u1;
        uvs[index + 1] = vBottom;
        uvs[index + 2] = u2;
        uvs[index + 3] = vBottom;
        uvs[index + 4] = u1;
        uvs[index + 5] = vTop;
        uvs[index + 6] = u2;
        uvs[index + 7] = vTop;
    }
    setHeadUVs(geo) {
        const uvs = geo.attributes.uv.array;
        this.setFaceUVs(uvs, 0, 16, 8, 8, 8, true);
        this.setFaceUVs(uvs, 1, 0, 8, 8, 8, true);
        this.setFaceUVs(uvs, 2, 8, 0, 8, 8, false);
        this.setFaceUVs(uvs, 3, 16, 0, 8, 8, false);
        this.setFaceUVs(uvs, 4, 8, 8, 8, 8, true);
        this.setFaceUVs(uvs, 5, 24, 8, 8, 8, true);
    }
    setBodyUVs(geo) {
        const uvs = geo.attributes.uv.array;
        this.setFaceUVs(uvs, 0, 16, 20, 4, 12, true);
        this.setFaceUVs(uvs, 1, 28, 20, 4, 12, true);
        this.setFaceUVs(uvs, 2, 20, 16, 8, 4, false);
        this.setFaceUVs(uvs, 3, 28, 16, 8, 4, false);
        this.setFaceUVs(uvs, 4, 20, 20, 8, 12, true);
        this.setFaceUVs(uvs, 5, 32, 20, 8, 12, true);
    }
    setRightArmUVs(geo) {
        const uvs = geo.attributes.uv.array;
        this.setFaceUVs(uvs, 0, 40, 20, 4, 12, true);
        this.setFaceUVs(uvs, 1, 48, 20, 4, 12, true);
        this.setFaceUVs(uvs, 2, 44, 16, 4, 4, false);
        this.setFaceUVs(uvs, 3, 48, 16, 4, 4, false);
        this.setFaceUVs(uvs, 4, 44, 20, 4, 12, true);
        this.setFaceUVs(uvs, 5, 52, 20, 4, 12, true);
    }
    setLeftArmUVs(geo) {
        const uvs = geo.attributes.uv.array;
        this.setFaceUVs(uvs, 0, 32, 52, 4, 12, true);
        this.setFaceUVs(uvs, 1, 40, 52, 4, 12, true);
        this.setFaceUVs(uvs, 2, 36, 48, 4, 4, false);
        this.setFaceUVs(uvs, 3, 40, 48, 4, 4, false);
        this.setFaceUVs(uvs, 4, 36, 52, 4, 12, true);
        this.setFaceUVs(uvs, 5, 44, 52, 4, 12, true);
    }
    setRightLegUVs(geo) {
        const uvs = geo.attributes.uv.array;
        this.setFaceUVs(uvs, 0, 8, 20, 4, 12, true);
        this.setFaceUVs(uvs, 1, 0, 20, 4, 12, true);
        this.setFaceUVs(uvs, 2, 4, 16, 4, 4, false);
        this.setFaceUVs(uvs, 3, 8, 16, 4, 4, false);
        this.setFaceUVs(uvs, 4, 4, 20, 4, 12, true);
        this.setFaceUVs(uvs, 5, 12, 20, 4, 12, true);
    }
    setLeftLegUVs(geo) {
        const uvs = geo.attributes.uv.array;
        this.setFaceUVs(uvs, 0, 24, 52, 4, 12, true);
        this.setFaceUVs(uvs, 1, 16, 52, 4, 12, true);
        this.setFaceUVs(uvs, 2, 20, 48, 4, 4, false);
        this.setFaceUVs(uvs, 3, 24, 48, 4, 4, false);
        this.setFaceUVs(uvs, 4, 20, 52, 4, 12, true);
        this.setFaceUVs(uvs, 5, 28, 52, 4, 12, true);
    }
    setHeadOverlayUVs(geo) {
        const uvs = geo.attributes.uv.array;
        const oX = 32;
        const oY = 0;
        this.setFaceUVs(uvs, 0, oX + 16, oY + 8, 8, 8, true);
        this.setFaceUVs(uvs, 1, oX + 0, oY + 8, 8, 8, true);
        this.setFaceUVs(uvs, 2, oX + 8, oY + 0, 8, 8, false);
        this.setFaceUVs(uvs, 3, oX + 16, oY + 0, 8, 8, false);
        this.setFaceUVs(uvs, 4, oX + 8, oY + 8, 8, 8, true);
        this.setFaceUVs(uvs, 5, oX + 24, oY + 8, 8, 8, true);
    }
    setBodyOverlayUVs(geo) {
        const uvs = geo.attributes.uv.array;
        const dy = 16;
        this.setFaceUVs(uvs, 0, 16, 20 + dy, 4, 12, true);
        this.setFaceUVs(uvs, 1, 28, 20 + dy, 4, 12, true);
        this.setFaceUVs(uvs, 2, 20, 16 + dy, 8, 4, false);
        this.setFaceUVs(uvs, 3, 28, 16 + dy, 8, 4, false);
        this.setFaceUVs(uvs, 4, 20, 20 + dy, 8, 12, true);
        this.setFaceUVs(uvs, 5, 32, 20 + dy, 8, 12, true);
    }
    setRightArmOverlayUVs(geo) {
        const uvs = geo.attributes.uv.array;
        const dy = 16;
        this.setFaceUVs(uvs, 0, 40, 20 + dy, 4, 12, true);
        this.setFaceUVs(uvs, 1, 48, 20 + dy, 4, 12, true);
        this.setFaceUVs(uvs, 2, 44, 16 + dy, 4, 4, false);
        this.setFaceUVs(uvs, 3, 48, 16 + dy, 4, 4, false);
        this.setFaceUVs(uvs, 4, 44, 20 + dy, 4, 12, true);
        this.setFaceUVs(uvs, 5, 52, 20 + dy, 4, 12, true);
    }
    setLeftArmOverlayUVs(geo) {
        const uvs = geo.attributes.uv.array;
        const dx = 16;
        this.setFaceUVs(uvs, 0, 32 + dx, 52, 4, 12, true);
        this.setFaceUVs(uvs, 1, 40 + dx, 52, 4, 12, true);
        this.setFaceUVs(uvs, 2, 36 + dx, 48, 4, 4, false);
        this.setFaceUVs(uvs, 3, 40 + dx, 48, 4, 4, false);
        this.setFaceUVs(uvs, 4, 36 + dx, 52, 4, 12, true);
        this.setFaceUVs(uvs, 5, 44 + dx, 52, 4, 12, true);
    }
    setRightLegOverlayUVs(geo) {
        const uvs = geo.attributes.uv.array;
        const dy = 16;
        this.setFaceUVs(uvs, 0, 8, 20 + dy, 4, 12, true);
        this.setFaceUVs(uvs, 1, 0, 20 + dy, 4, 12, true);
        this.setFaceUVs(uvs, 2, 4, 16 + dy, 4, 4, false);
        this.setFaceUVs(uvs, 3, 8, 16 + dy, 4, 4, false);
        this.setFaceUVs(uvs, 4, 4, 20 + dy, 4, 12, true);
        this.setFaceUVs(uvs, 5, 12, 20 + dy, 4, 12, true);
    }
    setLeftLegOverlayUVs(geo) {
        const uvs = geo.attributes.uv.array;
        // Left Leg Overlay (0, 48). Base (16, 48). Delta X = -16.
        const dx = -16;
        this.setFaceUVs(uvs, 0, 24 + dx, 52, 4, 12, true);
        this.setFaceUVs(uvs, 1, 16 + dx, 52, 4, 12, true);
        this.setFaceUVs(uvs, 2, 20 + dx, 48, 4, 4, false);
        this.setFaceUVs(uvs, 3, 24 + dx, 48, 4, 4, false);
        this.setFaceUVs(uvs, 4, 20 + dx, 52, 4, 12, true);
        this.setFaceUVs(uvs, 5, 28 + dx, 52, 4, 12, true);
    }
    addPixelGrid(mesh, width, height, depth) {
        let yOffset = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
        const positions = [];
        const halfWidth = width / 2;
        const halfHeight = height / 2;
        const halfDepth = depth / 2;
        const offset = 0.01;
        const addLine = (x1, y1, z1, x2, y2, z2)=>{
            positions.push(x1, y1 - yOffset, z1, x2, y2 - yOffset, z2);
        };
        for(let x = -halfWidth; x <= halfWidth; x += 1)addLine(x, -halfHeight, halfDepth + offset, x, halfHeight, halfDepth + offset);
        for(let y = -halfHeight; y <= halfHeight; y += 1)addLine(-halfWidth, y, halfDepth + offset, halfWidth, y, halfDepth + offset);
        for(let x1 = -halfWidth; x1 <= halfWidth; x1 += 1)addLine(x1, -halfHeight, -halfDepth - offset, x1, halfHeight, -halfDepth - offset);
        for(let y1 = -halfHeight; y1 <= halfHeight; y1 += 1)addLine(-halfWidth, y1, -halfDepth - offset, halfWidth, y1, -halfDepth - offset);
        for(let z = -halfDepth; z <= halfDepth; z += 1)addLine(halfWidth + offset, -halfHeight, z, halfWidth + offset, halfHeight, z);
        for(let y2 = -halfHeight; y2 <= halfHeight; y2 += 1)addLine(halfWidth + offset, y2, -halfDepth, halfWidth + offset, y2, halfDepth);
        for(let z1 = -halfDepth; z1 <= halfDepth; z1 += 1)addLine(-halfWidth - offset, -halfHeight, z1, -halfWidth - offset, halfHeight, z1);
        for(let y3 = -halfHeight; y3 <= halfHeight; y3 += 1)addLine(-halfWidth - offset, y3, -halfDepth, -halfWidth - offset, y3, halfDepth);
        for(let x2 = -halfWidth; x2 <= halfWidth; x2 += 1)addLine(x2, halfHeight + offset, -halfDepth, x2, halfHeight + offset, halfDepth);
        for(let z2 = -halfDepth; z2 <= halfDepth; z2 += 1)addLine(-halfWidth, halfHeight + offset, z2, halfWidth, halfHeight + offset, z2);
        for(let x3 = -halfWidth; x3 <= halfWidth; x3 += 1)addLine(x3, -halfHeight - offset, -halfDepth, x3, -halfHeight - offset, halfDepth);
        for(let z3 = -halfDepth; z3 <= halfDepth; z3 += 1)addLine(-halfWidth, -halfHeight - offset, z3, halfWidth, -halfHeight - offset, z3);
        const geometry = new three_core/* BufferGeometry */.u9r();
        geometry.setAttribute("position", new three_core/* Float32BufferAttribute */.a$l(positions, 3));
        const material = new three_core/* LineBasicMaterial */.nls({
            color: 0x000000,
            transparent: true,
            opacity: 0.3
        });
        const lines = new three_core/* LineSegments */.ejS(geometry, material);
        mesh.add(lines);
    }
    constructor(canvas){
        this.character = new three_core/* Group */.ZAu();
        this.originalSkinData = null;
        this.raycaster = new three_core/* Raycaster */.iMs();
        this.mouse = new three_core/* Vector2 */.FM8();
        this.isPainting = false;
        this.brushColor = "#FF0000";
        this.brushSize = 1;
        this.isEraser = false;
        this._isAnimating = false;
        this.animationTime = 0;
        this.animationFrameId = null;
        this.onResize = ()=>{
            var ref, ref1;
            if (!this.renderer) return;
            const canvas = this.renderer.domElement;
            const width = ((ref = canvas.parentElement) === null || ref === void 0 ? void 0 : ref.clientWidth) || 300;
            const height = ((ref1 = canvas.parentElement) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) || 400;
            this.camera.aspect = width / height;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(width, height);
        };
        this.onMouseDown = (e)=>{
            if (e.button === 0 && this.paint(e)) {
                this.isPainting = true;
                this.controls.enabled = false;
                e.preventDefault();
                e.stopPropagation();
            }
        };
        this.onMouseMove = (e)=>{
            if (this.isPainting) this.paint(e);
        };
        this.onMouseUp = ()=>{
            this.isPainting = false;
            this.controls.enabled = true;
        };
        this.animate = ()=>{
            this.animationFrameId = requestAnimationFrame(this.animate);
            if (this._isAnimating) {
                this.animationTime += 0.0625;
                const swing = Math.sin(this.animationTime) * 0.7;
                this.rightArm.rotation.x = swing;
                this.leftArm.rotation.x = -swing;
                this.rightLeg.rotation.x = -swing;
                this.leftLeg.rotation.x = swing;
            }
            this.controls.update();
            this.renderer.render(this.scene, this.camera);
        };
        this.init(canvas);
        this.createDefaultSkin();
        this.createCharacter();
        this.setupEventListeners(canvas);
        this.animate();
    }
}

// EXTERNAL MODULE: ./components/SkinGeneratorMenu/SkinGeneratorMenu.module.scss
var SkinGeneratorMenu_module = __webpack_require__(8715);
var SkinGeneratorMenu_module_default = /*#__PURE__*/__webpack_require__.n(SkinGeneratorMenu_module);
// EXTERNAL MODULE: ./node_modules/@carbon/icons-react/es/generated/bucket-13.js
var bucket_13 = __webpack_require__(8808);
// EXTERNAL MODULE: ./node_modules/@carbon/icons-react/es/generated/bucket-14.js
var bucket_14 = __webpack_require__(1409);
// EXTERNAL MODULE: ./node_modules/@carbon/icons-react/es/generated/bucket-6.js
var bucket_6 = __webpack_require__(6160);
// EXTERNAL MODULE: ./node_modules/@carbon/icons-react/es/generated/bucket-3.js
var bucket_3 = __webpack_require__(6194);
// EXTERNAL MODULE: ./node_modules/@carbon/icons-react/es/generated/bucket-18.js
var bucket_18 = __webpack_require__(3141);
// EXTERNAL MODULE: ./context/ToastContext.tsx
var ToastContext = __webpack_require__(5887);
// EXTERNAL MODULE: ./models/models.ts
var models = __webpack_require__(5029);
// EXTERNAL MODULE: ./context/CreditsContext.tsx
var CreditsContext = __webpack_require__(907);
// EXTERNAL MODULE: ./context/AuthContext.tsx
var AuthContext = __webpack_require__(175);
// EXTERNAL MODULE: ./components/buttons/ButtonPrimary/ButtonPrimary.tsx
var ButtonPrimary = __webpack_require__(3994);
// EXTERNAL MODULE: ./components/Modal/Modal.tsx
var Modal = __webpack_require__(5559);
// EXTERNAL MODULE: ./context/GoogleAnalyticsContext.tsx
var GoogleAnalyticsContext = __webpack_require__(2546);
// EXTERNAL MODULE: ./services/credits.ts
var credits = __webpack_require__(6634);
// EXTERNAL MODULE: ./components/buttons/ButtonPushable/ButtonPushable.tsx
var ButtonPushable = __webpack_require__(7272);
// EXTERNAL MODULE: ./components/icons/sale.tsx
var sale = __webpack_require__(7315);
;// CONCATENATED MODULE: ./components/icons/info.tsx

const InfoIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_114_116)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845886 10.121 0.00229405 8 0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.99261 1.46144 6.6994C1.71867 5.40619 2.35361 4.21831 3.28596 3.28596C4.21831 2.35361 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6647 9.76752 13.9617 11.4621 12.7119 12.7119C11.4621 13.9617 9.76752 14.6647 8 14.6667Z",
                        fill: "#6D6D94"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.99984 6.66666H7.33317C7.15636 6.66666 6.98679 6.73689 6.86177 6.86192C6.73674 6.98694 6.6665 7.15651 6.6665 7.33332C6.6665 7.51013 6.73674 7.6797 6.86177 7.80473C6.98679 7.92975 7.15636 7.99999 7.33317 7.99999H7.99984V12C7.99984 12.1768 8.07008 12.3464 8.1951 12.4714C8.32012 12.5964 8.48969 12.6667 8.6665 12.6667C8.84331 12.6667 9.01288 12.5964 9.13791 12.4714C9.26293 12.3464 9.33317 12.1768 9.33317 12V7.99999C9.33317 7.64637 9.19269 7.30723 8.94265 7.05718C8.6926 6.80713 8.35346 6.66666 7.99984 6.66666Z",
                        fill: "#6D6D94"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8 5.33334C8.55228 5.33334 9 4.88563 9 4.33334C9 3.78106 8.55228 3.33334 8 3.33334C7.44772 3.33334 7 3.78106 7 4.33334C7 4.88563 7.44772 5.33334 8 5.33334Z",
                        fill: "#6D6D94"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_114_116",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/CreditsForm/CreditsForm.tsx









const CreditsForm = ()=>{
    const { sendAnalyticsRecord  } = (0,GoogleAnalyticsContext/* useAnalytics */.z)();
    const { getPricePointsByCreditType  } = (0,CreditsContext/* useCredits */.B)();
    const pricePoints = getPricePointsByCreditType(models/* CreditType.minecraft */.LE.minecraft);
    const itemList = (0,credits/* transformPricePointsToItems */.uM)(pricePoints);
    const [loadingItemId, setLoadingItemId] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        sendAnalyticsRecord("view_item_list", {
            items: itemList
        });
    }, []);
    const handleClick = async (ecommerceItem)=>{
        setLoadingItemId(ecommerceItem.item_id);
        const checkoutSession = await (0,credits/* createCheckoutSession */.Mc)(ecommerceItem);
        sendAnalyticsRecord("begin_checkout", ecommerceItem);
        window.location.href = checkoutSession.url;
    };
    if (itemList.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center justify-center gap-3 p-8 text-secondary-foreground",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {
                    className: "w-10 h-10 opacity-80 [&_path]:fill-secondary-foreground mb-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-base text-center font-poppins",
                    children: "No credit packages are available at this time. Please check back later."
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col gap-8",
        children: itemList.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPushable/* default */.Z, {
                onClick: ()=>handleClick(item),
                loading: loadingItemId === item.item_id,
                disabled: loadingItemId !== null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative w-full flex justify-between items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/coin.png",
                            alt: "image of coin"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "font-poppins text-xl font-medium text-[#242C36]",
                            children: [
                                item.item_name,
                                " - $",
                                item.price.toFixed(2)
                            ]
                        }),
                        item.sale && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute -right-[1.4em] top-[2.2em] rotate-[55deg]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sale/* SaleIcon */.r, {})
                        })
                    ]
                })
            }, item.item_id))
    });
};
/* harmony default export */ var CreditsForm_CreditsForm = (CreditsForm);

// EXTERNAL MODULE: ./services/httpClient.ts + 40 modules
var httpClient = __webpack_require__(6230);
;// CONCATENATED MODULE: ./services/minecraft.ts

/**
 * @param msAccessToken - Microsoft OAuth access token from login
 * @returns Promise with verification result and Minecraft profile
 */ const verifyMinecraftOwnership = async (msAccessToken)=>{
    return httpInstance.post("/minecraft/verify-ownership", {
        ms_access_token: msAccessToken
    }).then((result)=>{
        return result;
    }).catch((error)=>{
        console.error("[MinecraftService] Ownership verification error:", error);
        throw error;
    });
};
/**
 * Upload a generated skin to the authenticated user's Minecraft account.
 *
 * SECURITY: This function does NOT send Microsoft tokens from the client.
 * The backend securely retrieves the MS token from the database for the authenticated user.
 *
 * @param generationId - ID of the generation containing the skin
 * @param imageIndex - Index of the specific image to upload (0-3 typically)
 * @param variant - Skin model variant: "classic" (Steve) or "slim" (Alex)
 * @returns Promise with upload result
 */ const uploadSkinToMinecraft = async function(generationId, imageIndex) {
    let variant = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "classic";
    // Authentication is handled via Firebase token in httpInstance interceptor
    // MS token is securely retrieved from database on the backend (NOT sent from client)
    return httpClient/* default.post */.Z.post("/minecraft/upload-skin?generation_id=".concat(generationId, "&image_index=").concat(imageIndex, "&variant=").concat(variant));
};
/**
 * @returns Promise with current skin information
 */ const getCurrentMinecraftSkin = async ()=>{
    return httpInstance.get("/minecraft/current-skin");
};
/**
 * Upload any skin (URL or Data URL) to the authenticated user's Minecraft account.
 * Use this for edited skins or skins not directly linked to a Generation ID.
 * 
 * @param skinUrl - The public URL or Data URL (base64) of the skin
 * @param variant - Skin model variant
 */ const uploadCustomSkinToMinecraft = async function(skinUrl) {
    let variant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "classic";
    return httpClient/* default.post */.Z.post("/minecraft/skin/upload", {
        skin_url: skinUrl,
        variant: variant
    });
};

;// CONCATENATED MODULE: ./components/SkinGeneratorMenu/SkinGeneratorMenu.tsx












const SkinGeneratorMenu = (props)=>{
    const [showCreditsModal, setShowCreditsModal] = (0,react.useState)(false);
    const [uploadingToMinecraft, setUploadingToMinecraft] = (0,react.useState)(false);
    const { getCreditCountByCreditType  } = (0,CreditsContext/* useCredits */.B)();
    const { user , connectMinecraft  } = (0,AuthContext/* useAuth */.aC)();
    const { showSuccessAlert , showErrorAlert  } = (0,ToastContext/* useToastContext */.a)();
    const downloadImage = async ()=>{
        try {
            var ref;
            const response = await fetch(props.artwork.image);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "skingenerator.png");
            document.body.appendChild(link);
            link.click();
            (ref = link.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(link);
        } catch (e) {
            console.error("Download failed:", e);
        }
    };
    const handleDeleteArtwork = async ()=>{
        props.deleteArtwork();
    };
    const handleToggleAnimation = ()=>{
        props.setToggleAnimation(!props.toggleAnimation);
    };
    const handleUploadToMinecraft = async ()=>{
        if (!user.has_minecraft) {
            showErrorAlert("Please connect your Minecraft account first");
            return;
        }
        const skinUrl = props.artwork.image;
        const isDataUrl = skinUrl && skinUrl.startsWith("data:");
        setUploadingToMinecraft(true);
        try {
            if (!skinUrl) {
                showErrorAlert("Cannot upload: No skin image found");
                return;
            }
            if (isDataUrl) {
                var ref;
                const response = await uploadCustomSkinToMinecraft(skinUrl, "classic");
                if ((ref = response.data) === null || ref === void 0 ? void 0 : ref.success) {
                    showSuccessAlert("Skin uploaded to Minecraft successfully!");
                } else {
                    showErrorAlert("Failed to upload skin to Minecraft");
                }
                setUploadingToMinecraft(false);
                return;
            }
            let generationId = props.artwork.id || "";
            if (!generationId && skinUrl) {
                const match = skinUrl.match(/v2_([a-f0-9-]+)_\d+_[a-f0-9-]+\.png/i);
                if (match && match[1]) {
                    generationId = match[1];
                }
            }
            if (generationId) {
                var ref1;
                const response1 = await uploadSkinToMinecraft(generationId, 0, "classic");
                if ((ref1 = response1.data) === null || ref1 === void 0 ? void 0 : ref1.success) {
                    showSuccessAlert("Skin uploaded to Minecraft successfully!");
                } else {
                    showErrorAlert("Failed to upload skin to Minecraft");
                }
            } else if (skinUrl) {
                var ref2;
                // Fallback: Try to upload by URL directly if we have a URL but no generation ID
                const response2 = await uploadCustomSkinToMinecraft(skinUrl, "classic");
                if ((ref2 = response2.data) === null || ref2 === void 0 ? void 0 : ref2.success) {
                    showSuccessAlert("Skin (from URL) uploaded successfully!");
                } else {
                    showErrorAlert("Failed to upload skin");
                }
            } else {
                showErrorAlert("Cannot upload: No skin image found");
            }
        } catch (error) {
            var ref3, ref4;
            const errorMessage = ((ref3 = error.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.detail) || error.message || "Failed to upload skin to Minecraft";
            showErrorAlert(errorMessage);
        } finally{
            setUploadingToMinecraft(false);
        }
    };
    const canUploadToMinecraft = Boolean(user === null || user === void 0 ? void 0 : user.has_minecraft);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SkinGeneratorMenu_module_default()).menu,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SkinGeneratorMenu_module_default()).credits,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (SkinGeneratorMenu_module_default()).bold,
                                children: getCreditCountByCreditType(models/* CreditType.minecraft */.LE.minecraft)
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Credits Left"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPrimary/* default */.Z, {
                        loading: false,
                        onClick: ()=>setShowCreditsModal(true),
                        text: "Buy Credits",
                        className: "w-full"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SkinGeneratorMenu_module_default()).actions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "".concat((SkinGeneratorMenu_module_default()).menuContentRow, " ").concat((SkinGeneratorMenu_module_default()).animate),
                        onClick: handleToggleAnimation,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (SkinGeneratorMenu_module_default()).DownloadIcon,
                                children: props.toggleAnimation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bucket_13/* Pause */.dz, {
                                    size: 24
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(bucket_14/* Play */.sh, {
                                    size: 24
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (SkinGeneratorMenu_module_default()).buttonLabel,
                                children: "Animate"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (SkinGeneratorMenu_module_default()).menuContentRow,
                        onClick: downloadImage,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (SkinGeneratorMenu_module_default()).DownloadIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bucket_6/* Download */.UW, {
                                    size: 24
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (SkinGeneratorMenu_module_default()).buttonLabel,
                                children: "Download"
                            })
                        ]
                    }),
                    canUploadToMinecraft && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (SkinGeneratorMenu_module_default()).menuContentRow,
                        onClick: handleUploadToMinecraft,
                        disabled: uploadingToMinecraft,
                        style: {
                            opacity: uploadingToMinecraft ? 0.6 : 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (SkinGeneratorMenu_module_default()).DownloadIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bucket_3/* CloudUpload */.nH, {
                                    size: 24
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (SkinGeneratorMenu_module_default()).buttonLabel,
                                children: uploadingToMinecraft ? "Uploading..." : "Set Active Skin"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "".concat((SkinGeneratorMenu_module_default()).menuContentRow, " ").concat((SkinGeneratorMenu_module_default()).danger),
                        onClick: handleDeleteArtwork,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (SkinGeneratorMenu_module_default()).DownloadIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bucket_18/* TrashCan */.ZN, {
                                    size: 24
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (SkinGeneratorMenu_module_default()).buttonLabel,
                                children: "Delete"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                showHeader: true,
                headerContent: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "headline-4",
                    children: "Buy Credits"
                }),
                width: "auto",
                height: "auto",
                isOpen: showCreditsModal,
                toggleModal: ()=>setShowCreditsModal(!showCreditsModal),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditsForm_CreditsForm, {})
            })
        ]
    });
};
/* harmony default export */ var SkinGeneratorMenu_SkinGeneratorMenu = (SkinGeneratorMenu);

// EXTERNAL MODULE: ./lib/firebaseClient.ts + 4 modules
var firebaseClient = __webpack_require__(8932);
// EXTERNAL MODULE: ./services/auth.ts
var auth = __webpack_require__(1137);
// EXTERNAL MODULE: ./components/EmailVerificationModal/EmailVerificationModal.module.scss
var EmailVerificationModal_module = __webpack_require__(1945);
var EmailVerificationModal_module_default = /*#__PURE__*/__webpack_require__.n(EmailVerificationModal_module);
;// CONCATENATED MODULE: ./components/icons/logout.tsx

const LogoutIcon = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "19",
        height: "21",
        viewBox: "0 0 19 21",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 1.5V19.5M6 10.5H17M17 10.5L14 7.5M17 10.5L14 13.5",
            stroke: "black",
            strokeWidth: "2",
            "stroke-linecap": "round"
        })
    });

;// CONCATENATED MODULE: ./components/EmailVerificationModal/EmailVerificationModal.tsx









const EMAIL_VERIFICATION_RETRY_LIMIT = 100;
const EMAIL_VERIFICATION_RETRY_INITIAL_DELAY = 5000;
const EMAIL_VERIFICATION_RETRY_DELAY_BACKOFF_RATE = 1250;
const EMAIL_VERIFICATION_RESEND_DELAY = 30000;
const EmailVerificationModal = ()=>{
    const [showEmailVerificationModal, setShowEmailVerificationModal] = (0,react.useState)(false);
    const [emailVerificationRetryCount, setEmailVerificationRetryCount] = (0,react.useState)(0);
    const [didResendEmailVerification, setDidResendEmailVerification] = (0,react.useState)(false);
    const { logout  } = (0,AuthContext/* useAuth */.aC)();
    const handleLogout = ()=>{
        logout();
    };
    (0,react.useEffect)(()=>{
        const checkEmailVerification = async ()=>{
            var ref;
            const isUserAuthenticated = Boolean(firebaseClient/* auth.currentUser */.I8.currentUser);
            const isEmailVerified = isUserAuthenticated && ((ref = firebaseClient/* auth.currentUser */.I8.currentUser) === null || ref === void 0 ? void 0 : ref.emailVerified);
            setShowEmailVerificationModal(isUserAuthenticated && !isEmailVerified);
            if (emailVerificationRetryCount >= EMAIL_VERIFICATION_RETRY_LIMIT) return;
            if (!isUserAuthenticated || !isEmailVerified) {
                setTimeout(async ()=>{
                    if (firebaseClient/* auth.currentUser */.I8.currentUser) {
                        await firebaseClient/* auth.currentUser.reload */.I8.currentUser.reload();
                    }
                    setEmailVerificationRetryCount(emailVerificationRetryCount + 1);
                }, EMAIL_VERIFICATION_RETRY_INITIAL_DELAY + EMAIL_VERIFICATION_RETRY_DELAY_BACKOFF_RATE * emailVerificationRetryCount);
            }
        };
        checkEmailVerification();
    }, [
        emailVerificationRetryCount
    ]);
    const resendEmailVerification = ()=>{
        if (!firebaseClient/* auth.currentUser */.I8.currentUser) return;
        if (didResendEmailVerification) return;
        (0,auth/* sendUserEmailVerification */.YH)(firebaseClient/* auth.currentUser */.I8.currentUser);
        setDidResendEmailVerification(true);
        setTimeout(()=>{
            setDidResendEmailVerification(false);
        }, EMAIL_VERIFICATION_RESEND_DELAY);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        showHeader: true,
        hideCloseButton: true,
        headerContent: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (EmailVerificationModal_module_default()).emailVerificationModalHeader,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "headline-4",
                children: "Verify Email"
            })
        }),
        width: "auto",
        height: "auto",
        isOpen: showEmailVerificationModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (EmailVerificationModal_module_default()).emailVerificationModalContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "In order to start using Skin Generator, please click the verification link in your email inbox."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Can't find an email from us? Click the button below to send another verification email:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                    className: "".concat((EmailVerificationModal_module_default()).emailVerificationModalButton, " ").concat(didResendEmailVerification && (EmailVerificationModal_module_default()).emailVerificationModalButtonDisabled),
                    onClick: resendEmailVerification,
                    loading: false,
                    disabled: didResendEmailVerification,
                    text: didResendEmailVerification ? "Verification email sent!" : "Re-send verification email"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Need to log in to a different account? Click the button below to log out:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                    className: (EmailVerificationModal_module_default()).emailVerificationModalButton,
                    onClick: handleLogout,
                    loading: false,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutIcon, {
                        width: "16",
                        height: "16",
                        color: "#B3005E"
                    }),
                    text: "Switch accounts"
                })
            ]
        })
    });
};
/* harmony default export */ var EmailVerificationModal_EmailVerificationModal = (EmailVerificationModal);

;// CONCATENATED MODULE: ./components/icons/gallery.tsx

const GalleryIcon = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "13",
                height: "13",
                rx: "2",
                fill: "#67c1f4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "17",
                width: "13",
                height: "13",
                rx: "2",
                fill: "#67c1f4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                y: "17",
                width: "13",
                height: "13",
                rx: "2",
                fill: "#67c1f4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "17",
                y: "17",
                width: "13",
                height: "13",
                rx: "2",
                fill: "#67c1f4"
            })
        ]
    });

// EXTERNAL MODULE: ./styles/pages/Generator.module.scss
var Generator_module = __webpack_require__(6536);
var Generator_module_default = /*#__PURE__*/__webpack_require__.n(Generator_module);
// EXTERNAL MODULE: ./services/artworks.ts
var services_artworks = __webpack_require__(8703);
// EXTERNAL MODULE: ./services/collection.ts
var collection = __webpack_require__(9701);
;// CONCATENATED MODULE: ./components/SkinPreviews/SkinPreviews.tsx



const PreviewCardLoader = (param)=>/*#__PURE__*/ {
    let { overlay  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "absolute inset-0 flex items-center justify-center rounded-xl ".concat(overlay ? "bg-black/40" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
            isLoading: true,
            width: 32,
            height: 32,
            color: "white"
        })
    });
};
const SkinPreviews = (param)=>{
    let { preview , handleSelectPreview , isApproving , selectedIndex  } = param;
    const [loadedImages, setLoadedImages] = (0,react.useState)(new Array(preview.images.length).fill(false));
    const markLoaded = (index)=>{
        setLoadedImages((prev)=>{
            const next = [
                ...prev
            ];
            next[index] = true;
            return next;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full max-h-full h-full sm:px-3 bg-background rounded-xl flex flex-col flex-start gap-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "flex-initial text-lg sm:text-3xl font-semibold text-center",
                children: "Select a skin"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-auto min-h-0 grid grid-cols-2 grid-rows-2 place-content-center place-items-stretch gap-3",
                children: preview.images.map((image, index)=>{
                    const isSelected = selectedIndex === index;
                    const isDisabled = isApproving;
                    const showApproving = isApproving && isSelected;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative bg-foreground rounded-xl p-6 bg-contain bg-no-repeat bg-center bg-origin-content transition-opacity ".concat(isDisabled ? "opacity-40 cursor-not-allowed" : "cursor-pointer", " ").concat(isApproving && isSelected ? "opacity-100" : ""),
                        style: loadedImages[index] ? {
                            backgroundImage: "url(".concat(image, ")")
                        } : undefined,
                        onClick: ()=>!isDisabled && handleSelectPreview(preview, index),
                        children: [
                            !loadedImages[index] && !showApproving && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewCardLoader, {}),
                            showApproving && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewCardLoader, {
                                overlay: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: image,
                                onLoad: ()=>markLoaded(index),
                                className: "hidden",
                                alt: ""
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var SkinPreviews_SkinPreviews = (SkinPreviews);

// EXTERNAL MODULE: ./components/GeneratingOverlay/GeneratingOverlay.tsx
var GeneratingOverlay = __webpack_require__(789);
;// CONCATENATED MODULE: ./pages/generator.tsx



















const Generator = ()=>{
    const [showEditor, setShowEditor] = (0,react.useState)(false);
    const handleEdit = ()=>{
        setShowEditor(true);
    };
    const handleEditorSave = (dataUrl)=>{
        setSkinUrl(dataUrl);
        setShowEditor(false);
    };
    const handleEditorCancel = ()=>{
        setShowEditor(false);
    };
    const { prompt , setPrompt  } = (0,SDContext/* useDiffusion */.PW)();
    const { sendAnalyticsRecord  } = (0,GoogleAnalyticsContext/* useAnalytics */.z)();
    const { preview , approveImage , resultImages , generateImages , generateImagesCallbackStore , isLoading , isApproving  } = (0,ImagineContext/* useImagine */.Y)();
    const { loadWallets  } = (0,CreditsContext/* useCredits */.B)();
    const isFormValid = prompt.value.length > 0;
    const [toggleAnimation, setToggleAnimation] = (0,react.useState)(true);
    const [skinUrl, setSkinUrl] = (0,react.useState)();
    const [skinPrompt, setSkinPrompt] = (0,react.useState)();
    const [artworkId, setArtworkId] = (0,react.useState)("");
    const [selectedCollectionId, setSelectedCollectionId] = (0,react.useState)("");
    const [retryCount, setRetryCount] = (0,react.useState)(0);
    const [artworks, setArtworks] = (0,react.useState)([]);
    const [showMobileGallery, setShowMobileGallery] = (0,react.useState)(false);
    const [selectedPreviewIndex, setSelectedPreviewIndex] = (0,react.useState)(null);
    const { showSuccessAlert , showWarningAlert , showErrorAlert  } = (0,ToastContext/* useToastContext */.a)();
    const loadUserArtworks = (0,react.useCallback)(async ()=>{
        const response = await (0,services_artworks/* getUserArtWorks */.Z7)();
        if (response.success && response.data) {
            const artworksData = response.data || [];
            loadWallets();
            setArtworks(artworksData);
        }
    }, [
        loadWallets
    ]);
    const handleSubmit = (0,react.useCallback)((images)=>{
        const handleSaveArtWork = async (artwork)=>{
            const saveFn = services_artworks/* saveArtWork */.Mo;
            saveFn(artwork).then((response)=>{
                if (response && response.success) {
                    setArtworkId(response.data.id);
                    loadUserArtworks();
                    loadWallets();
                    setSkinUrl(artwork.image);
                    setSkinPrompt(artwork.prompt);
                }
            }).catch((error)=>{
                console.error(error);
                showErrorAlert("Error saving artwork, please try again");
            });
        };
        // TODO: Refactor to not rely on indices
        const preview = images[0]["images"][1];
        const newSkinUrl = images[0]["images"][0];
        const newSkinPrompt = images[0].prompt;
        handleSaveArtWork({
            image: newSkinUrl,
            preview: preview,
            prompt: newSkinPrompt,
            title: "minecraft skin",
            collection_id: selectedCollectionId
        });
    }, [
        showErrorAlert,
        selectedCollectionId,
        loadUserArtworks,
        loadWallets
    ]);
    (0,react.useEffect)(()=>{
        const myCallback = (latestResult)=>{
            handleSubmit(latestResult);
        };
        generateImagesCallbackStore.add(myCallback);
        return ()=>generateImagesCallbackStore.remove(myCallback);
    }, [
        handleSubmit,
        generateImagesCallbackStore
    ]);
    (0,react.useEffect)(()=>{
        loadUserArtworks();
    }, [
        resultImages,
        loadUserArtworks
    ]);
    (0,react.useEffect)(()=>{
        const _artwork = artworks[0];
        if (!_artwork) return;
        // Only auto-select the first artwork if we are currently viewing the default 'notch.png'
        // This prevents overwriting a newly generated/selected skin when the gallery refreshes.
        const isDefault = !skinUrl || skinUrl.includes("notch.png");
        if (isDefault) {
            setSkinUrl(_artwork.image);
            setSkinPrompt(_artwork.prompt);
            if (_artwork.id) setArtworkId(_artwork.id);
        }
    }, [
        artworks,
        skinUrl
    ]);
    (0,react.useEffect)(()=>{
        const url = new URL("./notch.png", window.location.href);
        if (skinUrl === undefined) {
            setSkinUrl(url.href);
        }
    }, [
        skinUrl
    ]);
    (0,react.useEffect)(()=>{
        const fetchCollections = async ()=>{
            const response = await (0,collection/* getUserCollections */.nS)();
            if (response.success && response.data) {
                const collectionsData = response.data || [];
                setSelectedCollectionId(collectionsData[0].id);
            } else {
                if (retryCount < 10) {
                    setTimeout(()=>{
                        setRetryCount(retryCount + 1);
                    }, 500);
                }
            }
        };
        fetchCollections();
    }, [
        retryCount
    ]);
    const handleGenerate = ()=>{
        generateImages({
            option: "minecraft",
            prompt: prompt.value
        });
        sendAnalyticsRecord("generate_images", {
            prompt: prompt.value,
            model: "minecraft"
        });
    };
    const handleDeleteArtwork = async ()=>{
        if (!artworkId) {
            showWarningAlert("Looks like the item you're attempting to delete is not a Skin.");
            return;
        }
        showWarningAlert("Are you sure you want to delete this Skin?", "Confirm", deleteCallback);
    };
    const deleteCallback = ()=>{
        if (!artworkId) return;
        (0,services_artworks/* deleteArtWork */.$T)(artworkId).then((response)=>{
            if (response && response.success) {
                const remaining = artworks.filter((a)=>a.id !== artworkId);
                const next = remaining[0];
                if (next) {
                    setSkinUrl(next.image);
                    setSkinPrompt(next.prompt);
                    setArtworkId(next.id || "");
                } else {
                    setSkinUrl(undefined);
                    setSkinPrompt(undefined);
                    setArtworkId("");
                }
                loadUserArtworks();
                showSuccessAlert("Skin deleted successfully");
            }
        }).catch(()=>{
            showErrorAlert("An error occurred while deleting Skin, please try again later");
        });
    };
    const switchSkinRenderer = (artWork)=>{
        var ref;
        setSkinUrl(artWork.image);
        setSkinPrompt(artWork.prompt);
        setArtworkId(artWork.id || "");
        setShowMobileGallery(false);
        if ((ref = artWork.prompt) === null || ref === void 0 ? void 0 : ref.prompt) {
            var ref1;
            setPrompt({
                value: (ref1 = artWork.prompt) === null || ref1 === void 0 ? void 0 : ref1.prompt
            });
        }
    };
    const handleSelectPreview = (preview, approvedImageIndex)=>{
        setSelectedPreviewIndex(approvedImageIndex);
        approveImage(preview.request, preview.generationId, approvedImageIndex);
    };
    (0,react.useEffect)(()=>{
        if (!preview) setSelectedPreviewIndex(null);
    }, [
        preview
    ]);
    const activePreview = preview;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImagineContainer_ImagineContainer, {
        formValid: isFormValid,
        handleGenerate: handleGenerate,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneratingOverlay/* default */.Z, {
                isVisible: isLoading && !preview,
                estimatedSeconds: 30
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Generator_module_default()).imagesContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Generator_module_default()).results, " ").concat((Generator_module_default()).fullWidth, " ").concat(showMobileGallery && (Generator_module_default()).visible),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGallery_ImageGallery, {
                            onClick: switchSkinRenderer,
                            ArtWorks: artworks
                        })
                    }),
                    activePreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkinPreviews_SkinPreviews, {
                        preview: activePreview,
                        handleSelectPreview: handleSelectPreview,
                        isApproving: isApproving,
                        selectedIndex: selectedPreviewIndex
                    }),
                    !activePreview && skinUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(MinecraftSkin_MinecraftSkin, {
                        url: skinUrl,
                        toggleAnimation: toggleAnimation
                    }),
                    !activePreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Generator_module_default()).galleryToggleWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (Generator_module_default()).galleryToggle,
                            onClick: ()=>setShowMobileGallery(!showMobileGallery),
                            children: showMobileGallery ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Generator_module_default()).squareIcon
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryIcon, {})
                        })
                    })
                ]
            }),
            showEditor && skinUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    zIndex: 1000,
                    background: "#1a1b1e"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MinecraftSkinEditor, {
                    skinUrl: skinUrl,
                    onSave: handleEditorSave,
                    onCancel: handleEditorCancel
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkinGeneratorMenu_SkinGeneratorMenu, {
                artwork: {
                    id: artworkId,
                    image: skinUrl || "",
                    prompt: skinPrompt
                },
                deleteArtwork: handleDeleteArtwork,
                toggleAnimation: toggleAnimation,
                setToggleAnimation: setToggleAnimation,
                onEdit: handleEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailVerificationModal_EmailVerificationModal, {})
        ]
    });
};
/* harmony default export */ var generator = (Generator);


/***/ }),

/***/ 8703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$T": function() { return /* binding */ deleteArtWork; },
/* harmony export */   "MC": function() { return /* binding */ searchArtWorks; },
/* harmony export */   "Mo": function() { return /* binding */ saveArtWork; },
/* harmony export */   "Q6": function() { return /* binding */ getCollectionArtWorks; },
/* harmony export */   "Z7": function() { return /* binding */ getUserArtWorks; }
/* harmony export */ });
/* unused harmony exports saveArtWorks, getArtWorkDetails, updateArtWork */
/* harmony import */ var _httpClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6230);

const saveArtWorks = async (data)=>{
    try {
        const response = await httpInstance.post("/artworks/multiple", data);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const saveArtWork = async (data)=>{
    try {
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/artworks", data);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const getUserArtWorks = async ()=>{
    try {
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/artworks");
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const searchArtWorks = async (searchText)=>{
    try {
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/artworks/search?search=".concat(searchText));
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const getCollectionArtWorks = async (collectionId)=>{
    try {
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/artworks/collection/".concat(collectionId));
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const getArtWorkDetails = async (artWorkId)=>{
    try {
        const response = await httpInstance.get("/artworks/".concat(artWorkId));
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const updateArtWork = async (data)=>{
    try {
        const response = await httpInstance.put("/artworks", data);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const deleteArtWork = async (artWorkId)=>{
    try {
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .Z["delete"]("/artworks/".concat(artWorkId));
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};


/***/ }),

/***/ 9701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M7": function() { return /* binding */ getCollectionDetails; },
/* harmony export */   "P4": function() { return /* binding */ deleteCollection; },
/* harmony export */   "PR": function() { return /* binding */ saveCollection; },
/* harmony export */   "Rm": function() { return /* binding */ updateCollection; },
/* harmony export */   "nS": function() { return /* binding */ getUserCollections; }
/* harmony export */ });
/* harmony import */ var _httpClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6230);

const saveCollection = async (data)=>{
    try {
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/collections", data);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const getUserCollections = async ()=>{
    try {
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/collections");
        if (response.status === 200 && response.data.length > 0) {
            return {
                success: true,
                data: response.data
            };
        }
        return {
            success: false,
            error: "Collections not found"
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const getCollectionDetails = async (collectionId)=>{
    try {
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/collections/".concat(collectionId));
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const updateCollection = async (data)=>{
    try {
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .Z.put("/collections", data);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const deleteCollection = async (collectionId)=>{
    try {
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .Z["delete"]("/collections/".concat(collectionId));
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};


/***/ }),

/***/ 9383:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"artworkDetails":"ArtworkCardDetails_artworkDetails__0D5Yu","artworkImageContent":"ArtworkCardDetails_artworkImageContent__LFoo2","details":"ArtworkCardDetails_details__CIjTi"};

/***/ }),

/***/ 3835:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"creatorContainer":"ArtworkCreator_creatorContainer__UZRnY","creatorInfo":"ArtworkCreator_creatorInfo__t2NPY"};

/***/ }),

/***/ 1945:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"emailVerificationModalHeader":"EmailVerificationModal_emailVerificationModalHeader__QIRu4","emailVerificationModalContent":"EmailVerificationModal_emailVerificationModalContent__ORv4i","emailVerificationModalButton":"EmailVerificationModal_emailVerificationModalButton__c0KFB","emailVerificationModalButtonDisabled":"EmailVerificationModal_emailVerificationModalButtonDisabled__pgu7t"};

/***/ }),

/***/ 5236:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"galleryContainer":"ImageGallery_galleryContainer__P_BTE","promptResults":"ImageGallery_promptResults___7yC6","galleryRow":"ImageGallery_galleryRow__a8kQf","tooltip":"ImageGallery_tooltip__iQiVI","centeredContainer":"ImageGallery_centeredContainer__fY_xL","small":"ImageGallery_small__ss1f_","hide":"ImageGallery_hide__JNpcO"};

/***/ }),

/***/ 3631:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"TextArea_input__ZFTPu","default":"TextArea_default__ad4GL","textArea":"TextArea_textArea__fTdAh","inputContainer":"TextArea_inputContainer__O_wPp","defaultIconContainer":"TextArea_defaultIconContainer__8Z8xd","transparent":"TextArea_transparent__HSnTI","signature":"TextArea_signature___i3_p","caption-2":"TextArea_caption-2__oyp7X","caption-1":"TextArea_caption-1__yBqxq","error":"TextArea_error__Esqtr","base-2":"TextArea_base-2__WUXl9","base-1":"TextArea_base-1__8JYGE","body-3":"TextArea_body-3__G_IBY","body-2":"TextArea_body-2__QKUlz","body-1":"TextArea_body-1__xsxvj","headline-6":"TextArea_headline-6__7QdpO","headline-5":"TextArea_headline-5__dKlf4","headline-4":"TextArea_headline-4__XeszD","headline-3":"TextArea_headline-3__e6whn","headline-2":"TextArea_headline-2__5KYJp","headline-1":"TextArea_headline-1__qhThv","brand":"TextArea_brand___zTvq","button":"TextArea_button__vMBxt","bold64":"TextArea_bold64__z6cz8","bold40":"TextArea_bold40__HrZd7","heading":"TextArea_heading___lr2u","bodyBold":"TextArea_bodyBold__DIqLt","bigBody":"TextArea_bigBody__hFgV3","body":"TextArea_body__y2BCl","bold12":"TextArea_bold12__8qst0","boldSmall":"TextArea_boldSmall__3IhM_","small":"TextArea_small__n40h_","main":"TextArea_main__MfnSI","accent":"TextArea_accent__VKK7a","primary":"TextArea_primary__KLD0E","secondary":"TextArea_secondary__tWmGL","success":"TextArea_success___wq5k","info":"TextArea_info__Ezpel","danger":"TextArea_danger__Fia_Z","white":"TextArea_white__HXu2F","grey":"TextArea_grey__PcV5l","black":"TextArea_black__x5zLv","mainColor":"TextArea_mainColor__VedXi","upper":"TextArea_upper__4i46Y","capitalize":"TextArea_capitalize__PzRRc","underline":"TextArea_underline__6hC3n","lineThrough":"TextArea_lineThrough__J9UFy","ellipsis":"TextArea_ellipsis__uc5k4","pointer":"TextArea_pointer__BAmXV","shadow":"TextArea_shadow__OPW7c","center":"TextArea_center____7UZ","left":"TextArea_left__rPjXB","right":"TextArea_right__yWIxl","pLeft":"TextArea_pLeft__6lJHk","pRight":"TextArea_pRight__4SEwm","iconLeft":"TextArea_iconLeft__8_N_c","iconRight":"TextArea_iconRight__tJZo_","active":"TextArea_active__BXM7_","rightIcon":"TextArea_rightIcon__xb5RU","count":"TextArea_count__DpG3i","colour":"TextArea_colour__Jb6Ek TextArea_default__ad4GL"};

/***/ }),

/***/ 5558:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"galleryContainer":"MinecraftSkin_galleryContainer__nASH9","promptResults":"MinecraftSkin_promptResults__WeliY","galleryRow":"MinecraftSkin_galleryRow__UqbEy","minecraftSkinContainer":"MinecraftSkin_minecraftSkinContainer__44zZP","centeredContainer":"MinecraftSkin_centeredContainer__6Qae8","small":"MinecraftSkin_small__Tzkf4","hide":"MinecraftSkin_hide__SR97t"};

/***/ }),

/***/ 8429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"MinecraftSkinEditor_container__LZ4RY","controlsOverlay":"MinecraftSkinEditor_controlsOverlay__HaZ8G","colorPickerContainer":"MinecraftSkinEditor_colorPickerContainer__OBIUO","colorSwatch":"MinecraftSkinEditor_colorSwatch__duJgB","active":"MinecraftSkinEditor_active__kfvT_","toolsContainer":"MinecraftSkinEditor_toolsContainer__QtkR4","toolButton":"MinecraftSkinEditor_toolButton__Gkp_U"};

/***/ }),

/***/ 8715:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"actions":"SkinGeneratorMenu_actions__vPNxR","menu":"SkinGeneratorMenu_menu__e1cA_","credits":"SkinGeneratorMenu_credits__65Tm3","bold":"SkinGeneratorMenu_bold__KRyzK","creditCounter":"SkinGeneratorMenu_creditCounter__MgEJV","menuContentRow":"SkinGeneratorMenu_menuContentRow__o_T33","buttonLabel":"SkinGeneratorMenu_buttonLabel__V9aBm","danger":"SkinGeneratorMenu_danger__ZI3vm","DownloadIcon":"SkinGeneratorMenu_DownloadIcon__TYrpt","animate":"SkinGeneratorMenu_animate__6DT4J","rightBarIcon":"SkinGeneratorMenu_rightBarIcon__BCFz5"};

/***/ }),

/***/ 6820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imagineContainer":"ImagineContainer_imagineContainer__ISQ3d","imagineContent":"ImagineContainer_imagineContent__MzxEf","mainContent":"ImagineContainer_mainContent__2_8u5","children":"ImagineContainer_children__9gJPK","input":"ImagineContainer_input__bIUZv","imagineInputContainer":"ImagineContainer_imagineInputContainer__ZgCFy","inputText":"ImagineContainer_inputText__fR9bi","ImagineActions":"ImagineContainer_ImagineActions__mlb2F"};

/***/ }),

/***/ 6536:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imagesContent":"Generator_imagesContent__AQoM4","inputImage":"Generator_inputImage__v2G4D","results":"Generator_results__xwMC5","visible":"Generator_visible__287BE","squareIcon":"Generator_squareIcon__pIeWF","galleryToggleWrapper":"Generator_galleryToggleWrapper__sUZLv","galleryToggle":"Generator_galleryToggle__7T43_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [737,934,160,289,125,557,328,460,774,888,179], function() { return __webpack_exec__(2329); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);